
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.005 24A11.951 11.951 0 019 23.616a.5.5 0 01-.374-.51 2.95 2.95 0 00-4.554-2.627.5.5 0 01-.63-.069 12.089 12.089 0 01-3-5.2.5.5 0 01.255-.58 2.952 2.952 0 001.291-3.966A2.928 2.928 0 00.693 9.372a.5.5 0 01-.255-.579 12.025 12.025 0 013-5.2.5.5 0 01.629-.068 2.954 2.954 0 004.08-.865A2.931 2.931 0 008.622.892.5.5 0 019 .381a12.029 12.029 0 016 .003.5.5 0 01.374.51 2.95 2.95 0 004.554 2.627.5.5 0 01.63.069 12.085 12.085 0 013 5.2.5.5 0 01-.255.579 2.95 2.95 0 000 5.257.5.5 0 01.255.579 12.036 12.036 0 01-3 5.2.5.5 0 01-.63.069 2.95 2.95 0 00-4.553 2.629.5.5 0 01-.374.511 12.01 12.01 0 01-2.996.386zm-2.383-1.262a11.015 11.015 0 004.757 0 3.95 3.95 0 015.733-3.31 11.036 11.036 0 002.377-4.121 3.95 3.95 0 010-6.619 11.109 11.109 0 00-2.378-4.12 3.95 3.95 0 01-4.725-.879 3.921 3.921 0 01-1.009-2.429 10.984 10.984 0 00-4.757 0 3.938 3.938 0 01-.632 1.94 3.95 3.95 0 01-5.1 1.369 11.028 11.028 0 00-2.377 4.122 3.923 3.923 0 011.364 1.518 3.958 3.958 0 01-1.365 5.1 10.96 10.96 0 00.966 2.191 11.075 11.075 0 001.412 1.93 3.966 3.966 0 012-.423 3.951 3.951 0 013.737 3.731zM12 15.949A3.949 3.949 0 1115.949 12 3.953 3.953 0 0112 15.949zm0-6.9A2.949 2.949 0 1014.949 12 2.952 2.952 0 0012 9.051z"}})])
          )
        }
      }
    